<template>
  <form @submit.prevent="verify">
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="GithubIcon" class="mr-2 c-primary" />
        <span class="font-medium text-lg leading-none"> Dati Anagrafici</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-5/12 w-full px-2">
        <label class="vs-input--label">Cognome</label>
        <vs-input v-model="form.tiroc_cognome" :disabled="is_readonly" class="w-full" />
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Nome</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_nome" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <label class="vs-input--label">Codice fiscale</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_cf" pattern="[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <label class="vs-input--label">Cittadinanza</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_cit" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Luogo di nascita</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_birth_place" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-2/12 w-full px-2">
        <label class="vs-input--label">Provincia di nascita</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_birth_prov" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <label class="vs-input--label">Data di nascita</label>
        <vs-input type="date" :disabled="is_readonly" v-model="form.tiroc_birth_date" class="w-full"/>
        <!-- <v-date typeable :disabled="is_readonly" placeholder="Scegli la data" v-model="form.tiroc_birth_date" :language="$date_lang" :monday-first="true" format="d MMM yyyy" initial-view="year"/> -->
      </vs-col>

      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Email</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_email" type="email" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Telefono</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_tel" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Ultimo titolo di studio conseguito</label>
        <vs-select class="w-full" :disabled="is_readonly" v-model="form.tiroc_titolo_studio">
          <vs-select-item v-for="(label, id) in $tir.studio_types" :key="id" :value="id" :text="label" />
        </vs-select>
      </vs-col>

      <vs-col class="md:w-5/12 w-full px-2">
        <label class="vs-input--label">Indirizzo di residenza</label>
        <vs-input :disabled="is_readonly" @input="form.tiroc_same_domic && $set(form, 'tiroc_domicilio', form.tiroc_residenza)" v-model="form.tiroc_residenza" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-2/12 w-full px-2">
        <label class="vs-input--label">CAP</label>
        <vs-input :disabled="is_readonly" @input="form.tiroc_same_domic && $set(form, 'tiroc_domicilio_cap', form.tiroc_residenza_cap)" v-model="form.tiroc_residenza_cap" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Comune</label>
        <vs-input :disabled="is_readonly" @input="form.tiroc_same_domic && $set(form, 'tiroc_domicilio_comune', form.tiroc_residenza_comune)" v-model="form.tiroc_residenza_comune" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-1/12 w-full px-2">
        <label class="vs-input--label">Provincia</label>
        <vs-input :disabled="is_readonly" @input="form.tiroc_same_domic && $set(form, 'tiroc_domicilio_prov', form.tiroc_residenza_prov)" v-model="form.tiroc_residenza_prov" class="w-full"/>
      </vs-col>

      <vs-col class="md:w-12/12 w-full px-2 mt-2 mb-2">
        <vs-checkbox :disabled="is_readonly" v-model="form.tiroc_same_domic" @input="$event && $set(form, 'tiroc_domicilio', form.tiroc_residenza)">
          Domicilio diverso da residenza
        </vs-checkbox>
      </vs-col>

      <vs-col class="md:w-5/12 w-full px-2" v-if = "form.tiroc_same_domic">
        <label class="vs-input--label">Indirizzo del domicilio</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_domicilio" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-2/12 w-full px-2" v-if = "form.tiroc_same_domic">
        <label class="vs-input--label">CAP</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_domicilio_cap" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2" v-if = "form.tiroc_same_domic">
        <label class="vs-input--label">Comune</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_domicilio_comune" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-1/12 w-full px-2" v-if = "form.tiroc_same_domic">
        <label class="vs-input--label">Provincia</label>
        <vs-input :disabled="is_readonly" v-model="form.tiroc_domicilio_prov" class="w-full"/>
      </vs-col>
    </vs-row>

    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="PocketIcon" class="mr-2 c-primary"/>
        <span class="font-medium text-lg leading-none">Documento di riconoscimento</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-4/12 w-full px-2">
        <vx-tooltip text="Se vuoto, non vengono salvati tutti i campi in grigio">
          <label class="vs-input--label">Permesso di soggiorno</label>
          <vs-input :disabled="is_readonly" v-model="form.tiroc_permsogg" class="w-full"/>
        </vx-tooltip>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Questura</label>
        <vs-input :disabled="is_readonly || !form.tiroc_permsogg" v-model="form.tiroc_permsogg_questura" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Motivo del soggiorno</label>
        <vs-input :disabled="is_readonly || !form.tiroc_permsogg" v-model="form.tiroc_permsogg_motivo" class="w-full"/>
      </vs-col>

      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Data rilascio</label>
        <vs-input type="date" :disabled="is_readonly || !form.tiroc_permsogg" v-model="form.tiroc_permsogg_rilascio" class="w-full"/>
        <!-- <v-date typeable :disabled="is_readonly || !form.tiroc_permsogg" :language="$date_lang" :monday-first="true" format="d MMM yyyy" v-model="form.tiroc_permsogg_rilascio"/> -->
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Data rinnovo</label>
        <v-date typeable :disabled="is_readonly || !form.tiroc_permsogg" :language="$date_lang" :monday-first="true" format="d MMM yyyy" v-model="form.tiroc_permsogg_rinnovo"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Data scadenza</label>
        <v-date typeable :disabled="is_readonly || !form.tiroc_permsogg" :language="$date_lang" :monday-first="true" format="d MMM yyyy" v-model="form.tiroc_permsogg_scadenza"/>
      </vs-col>
    </vs-row>

    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="RadioIcon" class="mr-2 c-primary" />
        <span class="font-medium text-lg leading-none">Maggiori informazioni</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-6/12 w-full px-2">
        <vs-row class="w-full px-2">
          <vs-checkbox :disabled="is_readonly" v-model="form.tiroc_obbligo_scolastico">Assolvimento obbligo scolastico</vs-checkbox>
        </vs-row>
        <vs-row class="w-full px-2 mt-2">
          <vs-checkbox :disabled="is_readonly" v-model="form.tiroc_svolgimento_tirocini_prec">Svolgimento tirocini formativi precedenti</vs-checkbox>
        </vs-row>
        <vs-row class="w-full px-2 mt-2  ml-2">
          <p style="margin-left:2px;">Conseguimento attestato di qualifica professionale?</p>
        </vs-row>
        <vs-row class="w-full px-2 mt-2">
          <vs-radio vs-name="radiosAttestato" class="ml-2" :disabled="is_readonly" v-model="form.tiroc_attestato_qualifica_prof" :vs-value="true">Si</vs-radio>
          <vs-radio vs-name="radiosAttestato" class="ml-2" :disabled="is_readonly" v-model="form.tiroc_attestato_qualifica_prof" :vs-value="false">No</vs-radio>
          <vs-input v-if="form.tiroc_attestato_qualifica_prof" v-model="form.tiroc_attestato_qualifica_prof_str" :disabled="is_readonly" label="Indicare la qualifica professionale conseguita" class="w-full mt-2"/>
        </vs-row>
        <vs-row class="w-full px-2 mt-2  ml-2">
          <p style="margin-left:2px;">Condizione di disabilità/svantaggio</p>
        </vs-row>
        <vs-row class="w-full px-2 mt-2">
          <vs-radio vs-name="radiosCondizioni" class="ml-2" :disabled="is_readonly" v-model="form.tiroc_condizioni" :vs-value="true">Si</vs-radio>
          <vs-radio vs-name="radiosCondizioni" class="ml-2" :disabled="is_readonly" v-model="form.tiroc_condizioni" :vs-value="false">No</vs-radio>
        </vs-row>
      </vs-col>
      <vs-col class="md:w-6/12 w-full px-2">
        <vs-row class="w-full px-2">
          <vs-checkbox class="w-full" :disabled="is_readonly" v-model="form.tiroc_rapp_precedenti">Svolgimento rapporti di lavoro precedenti con l'azienda</vs-checkbox>
        </vs-row >
        <vs-row class="w-full px-2 mt-2">
          <vs-checkbox class="w-full" :disabled="is_readonly" v-model="form.tiroc_sostegno_reddito">&nbsp;Percepimento forme di sostegno al reddito</vs-checkbox>
        </vs-row >
        <vs-row v-if="form.tiroc_sostegno_reddito" class="w-full px-2">
          <vs-col class="md:w-6/12 w-full px-2">
            <label class="vs-input--label">Periodo dal</label>
            <v-date typeable: disabled="is_readonly" placeholder="Scegli la data" v-model="form.tiroc_sostegno_reddito_dal" :language="$date_lang" :monday-first="true" format="d MMM yyyy"/>
          </vs-col>
          <vs-col class="md:w-6/12 w-full px-2">
            <label class="vs-input--label">Periodo al</label>
            <v-date typeable: disabled="is_readonly" placeholder="Scegli la data" v-model="form.tiroc_sostegno_reddito_al" :language="$date_lang" :monday-first="true" format="d MMM yyyy"/>
          </vs-col>
        </vs-row >
        <vs-row class="w-full px-2">
          <vx-tooltip text="Clicca sul link per effettuare la registrazione al portale">
            <vs-checkbox class="w-full mt-4" :disabled="is_readonly" v-model="form.tiroc_portale_per_te">Accreditamento
              <a href="https://lavoroperte.regione.emilia-romagna.it/">Lavoro per Te Regione Emilia Romagna</a></vs-checkbox>
          </vx-tooltip>
        </vs-row >
      </vs-col>
    </vs-row>
  </form>
</template>

<script>
export default {
  props: ['form','is_readonly'],
  components: {
  },

  // created() {
  //   console.log(this.form['tiroc_attestato_qualifica_prof']);
  //   // if (this.form)
  //   // this.form['tiroc_attestato_qualifica_prof'] = null
  // },

  data () {
    return {
      is_saving: false,
    }
  },

  computed: {
    az () {
      return this.form.azienda
    },
  },

  methods: {
    save() {
      this.is_saving = true
      this.$http.post(`modulo-tirocinio/salva?token=${this.form.token}`, this.form).then(res => {
        this.$parent.$parent.nextTab()
      }).finally(res => {
        this.is_saving = false
      })
    },
  },
}
</script>

<style lang="css">
</style>
